import { render, staticRenderFns } from "./Request.vue?vue&type=template&id=4ff94706&scoped=true&"
import script from "./Request.vue?vue&type=script&lang=js&"
export * from "./Request.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff94706",
  null
  
)

export default component.exports